import React from 'react';
import { useTranslation } from 'react-i18next';

const Error500 = () => {
  const { t } = useTranslation();
  return <div>{t('error.500')}</div>;
};

Error500.propTypes = {};

export default Error500;
